import React from "react";
import Top from "./pages/Top";

function App() {
  return <Top />;
}

export default App;
